import FontFaceObserver from "fontfaceobserver";

export function loadFont(fontName, fontWeight) {
  return new FontFaceObserver(fontName, { weight: fontWeight }).load();
}
